<template>
  <intro-box>
    <div class="herocard-content text-content" v-html="description" />

    <div class="introduction-spacer"></div>
    <div class="bottom_align">
      <button type="button" class="button is-primary is-rounded right" @click="goToFirstStep">
        Jag förstår, nu kör vi!
      </button>
    </div>
  </intro-box>
</template>

<script>
import IntroBox from '@/components/elements/IntroBox.vue'
const SITE_URL = process.env.SITE_URL

export default {
  computed: {
    task() {
      return this.$store.state.assignment.task
    },
    assignment() {
      return this.$store.state.assignment
    },
    chapter() {
      return this.$store.state.assignment.chapter
    },
    audioframe_src: function(){
      let material_source = this.chapter.source_folder
      return SITE_URL + '/videos/audioframe.html?filename=' + material_source + '/' + material_source + '_herocard';
    },
    continue_chapter(){
      return this.$store.state.continue_chapter
    },
    show_chapter_intro(){
      return this.$store.state.show_chapter_intro
    },
    description() {
      let iframe = "<iframe src='" + this.audioframe_src +"' style='width:100%;height:45px;margin-top:45px;' frameborder='0'></iframe>"
      return this.chapter.herocard + iframe
    }
  },
  components: {
    IntroBox
  },
  methods: {
    goToFirstStep() {
      if(this.task.scene_number){
        // when task has scene_number, load video
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/video`})
      } else {
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/introduction`})
      }

    }
  },
  mounted: function() {
    if (this.assignment && this.assignment.status == "completed") {
      this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/confirmation`})
    }else{
      if (!this.chapter.task_chapter){
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/introduction`})
      }
    }
  }
}
</script>
<style>
  .button {
    margin-top: auto;
    bottom: 0;
  }
</style>
